import { Injectable } from '@angular/core';
import { Headers, Http, Request } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { Subscription } from "rxjs";
import 'rxjs/add/operator/map';

import draConfig from '../config';
import helper from '../helper';

@Injectable()
export class ApiService {
  static API_SUCCESS = true;

  private baseURL: string = draConfig.apiURL;
  private subscriptions: Map<string, Subscription> = new Map();
  private token: string;

  constructor(private http: Http) {
  }

  public setToken(_token: string): void {
    this.token = _token;
  }

  public call(endPoint: string, method: string, params?: Object): Promise<any> {
    return helper.toPromise(this._call(endPoint, method, params), endPoint, this.subscriptions);
  }

  public callOnce(endPoint: string, method: string, params?: Object): Promise<any> {
    this.clear(endPoint);
    return this.call(endPoint, method, params);
  }

  private clear(name: string): void {
    let subscription = this.subscriptions.get(name);
    if (!subscription) return;
    this.subscriptions.delete(name);
    subscription.unsubscribe();
  }

  private _call(endPoint: string, method: string, params?: Object): Observable<any> {
    method = method.toUpperCase();

    return this.http
      .request(new Request({
        url: `${this.baseURL}/${endPoint}`,
        method: method,
        params: (method == 'GET') ? helper.toQueryParams(params) : null,
        body: params,
        headers: new Headers({})
      }))
      .map(response => response.json())
      .map(
        result => {
          if (result.status === ApiService.API_SUCCESS) {
            return result.data;
          } else {
            let message = result.message;

            throw {
              message: message,
              data: result.data
            };
          }
        },
        response => {
          if (response.status === 401) {
            throw {
              message: response.text(),
              fatal: true,
              loggedOut: true,
            };
          }
          if (response.message) {
            throw response;
          }
          throw {
            message: 'SYS_ERR_001'
          };
        }
      )
    ;
  }
}



// WEBPACK FOOTER //
// ./src/services/api.service.ts